import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BottomNav } from "@/components/BottomNav";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Today from "@/pages/Today";
import BrainDump from "@/pages/BrainDump";
import NextRightThing from "@/pages/NextRightThing";
import TrustDeposits from "@/pages/TrustDeposits";
import ParkingLot from "@/pages/ParkingLot";
import AllTasks from "@/pages/AllTasks";
import Settings from "@/pages/Settings";
import WinLog from "@/pages/WinLog";
import Trash from "@/pages/Trash";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
        <p className="text-zinc-500 text-sm">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="max-w-md mx-auto min-h-screen relative">
      <Outlet />
      <BottomNav />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Today />} />
        <Route path="/brain-dump" element={<BrainDump />} />
        <Route path="/next" element={<NextRightThing />} />
        <Route path="/trust" element={<TrustDeposits />} />
        <Route path="/parking-lot" element={<ParkingLot />} />
        <Route path="/tasks" element={<AllTasks />} />
        <Route path="/wins" element={<WinLog />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to={location.pathname === "/login" ? "/login" : "/"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-zinc-900 min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
